import md5 from "blueimp-md5";

/**
 * Generates an MD5 hash based on object properties
 */
export default function getObjectSignature(object = {}): string | null {
    if (typeof object !== "object" || Array.isArray(object)) {
        return null;
    }

    const methodNames = Object.getOwnPropertyNames(object).sort()
        .join(":");

    return md5(methodNames);
}
